const getScrollStatus = (rootState) => rootState.ws.view.isScrolling;

export default getScrollStatus;
